// extracted by mini-css-extract-plugin
module.exports = {"SearchSort":"Sort_SearchSort__x8fIY","SearchSort__Select":"Sort_SearchSort__Select__COFwU","RemoveAutofill":"Sort_RemoveAutofill__Ahhhx","loader":"Sort_loader__FOkAy"};